import pickBy from 'lodash/pickBy';
import { TOAST_ID } from '@domain/_screens/workflow/manual-card/due-date/due-date.constants';
import { SIGN_IN_WARNING_TEXTS } from '@domain/auth/sign-in/sign-in.constants';
import { showToast, TOAST_TYPE } from '@shared/components/messages-and-errors/ToastsNotifications';

export const pickNonUndefined = obj => pickBy(obj, value => typeof value !== 'undefined');

export const showWarning = (action) => {
    const warningText = SIGN_IN_WARNING_TEXTS[action.type];
    if (warningText) {
        showToast(
            warningText,
            TOAST_TYPE.WARNING,
            { autoClose: 50000, toastId: TOAST_ID, height: 200 },
        );
    }
};
